import type { PackageState } from "../slice";

export const getPackageStateByLodgingId = (state: PackageState) => {
  return state.packages.hotel.availability.data?.packagesByLodgingId;
};

export const getPackageAvailabilityDateRange = (state: PackageState) => {
  return state.packages.hotel.availability.data?.dateRange;
};
